import { render, staticRenderFns } from "./insuranceMessage.vue?vue&type=template&id=e6d5e0fc&scoped=true&"
import script from "./insuranceMessage.vue?vue&type=script&lang=js&"
export * from "./insuranceMessage.vue?vue&type=script&lang=js&"
import style0 from "./insuranceMessage.vue?vue&type=style&index=0&id=e6d5e0fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d5e0fc",
  null
  
)

export default component.exports